import type { Messages } from './en';

/** 尋寶文字。謎語本身保留英文（見 content/treasure.ts）。 */
export const zhTWTreasure: Pick<Messages, 'treasure'> = {
  treasure: {
    title: '🏴‍☠️ 尋寶遊戲',
    intro: '今天藏了三個寶藏。讀讀英文線索，跟著指南針走，等它顯示「⛏️ 就是這裡，快挖！」的時候就開挖吧。',
    clue: (n: number) => `線索 ${n}`,
    listen: '🔊 聽聽看',
    translate: '🌐 用我的語言提示',
    follow: '🧭 追這條線索',
    following: '🧭 追蹤中',
    done: '✅ 找到了！',
    heat: ['🧊 好冷', '🌤️ 有點溫', '☀️ 更溫了', '🔥 好燙！', '⛏️ 就是這裡，快挖！'],
    otherMap: '🧭 不在這裡，換個地方找找',
    dig: '⛏️ 在這裡挖',
    found: '你找到一個寶箱了！',
    foundItem: (icon: string, name: string) => `寶藏！你找到了：${icon} ${name}`,
    allFound: '🏆 今天的寶藏全部找到了！獎勵 +10⭐ +30🪙',
    albumTitle: '寶藏圖鑑',
    album: {
      coin: '古老錢幣', marble: '玻璃彈珠', shell: '螺旋貝殼', robot: '鐵皮機器人', postcard: '老明信片', charm: '幸運御守',
      compass: '黃銅指南針', feather: '金色羽毛', stamp: '稀有郵票', crystal: '藍色水晶', whistle: '銀色哨子', medal: '英雄獎牌',
    },
    hints: {
      fountain: '在噴水池旁邊（鎮上或百貨公司）。',
      pond: '在公園池塘的邊邊。',
      cherry: '在學校中庭的櫻花樹下。',
      busStop: '在大街上的公車站旁邊。',
      slide: '在遊樂場的溜滑梯旁邊。',
      hay: '在馬場的乾草堆旁邊。',
      tennis: '在網球場的一個角落。',
      track: '在跑道的一個角落。',
      mailbox: '在你家門口的紅色郵筒旁邊。',
      kiteTree: '在社區裡的大樹下。',
      library: '在圖書館裡，閱讀桌附近。',
      piano: '在音樂教室裡，鋼琴旁邊。',
      easel: '在美術教室裡，畫架附近。',
      pool: '在游泳池，救生員的椅子附近。',
      store: '在巷口的雜貨店裡，貨架之間。',
      sofa: '在家裡，客廳沙發附近。',
    },
  },
};
